import { stdnum } from 'stdnum'
//https://github.com/koblas/stdnum-js#readme

export const valideImmatriculation = (immatriculation: string, codePays: string): boolean => {
  if (immatriculation)
    switch (codePays) {
      case "FR": return verifyFR(immatriculation)
      case "IT": return verifyIT(immatriculation)
      case "ES": return verifyES(immatriculation)
      case "BE": return verifyBE(immatriculation)
      case "LU": return verifyLU(immatriculation)
      case "NL": return verifyNL(immatriculation)
      case "GB": return verifyGB(immatriculation)
      case "DE": return verifyDE(immatriculation)
      default: return true
    }
  return true
}

export const immatriculationName = (codePays: string): string => {

  switch (codePays) {
    case "FR": return stdnum.FR.siren.abbreviation + "/" + stdnum.FR.siret.abbreviation
    case "IT": return stdnum.IT.iva.abbreviation + ""
    case "ES": return stdnum.ES.nif.abbreviation + ""
    case "BE": return stdnum.BE.vat.abbreviation + ""
    case "LU": return stdnum.LU.tva.abbreviation + ""
    case "NL": return stdnum.NL.btw.abbreviation + ""
    case "GB": return stdnum.GB.vat.abbreviation + ""
    case "DE": return stdnum.DE.vat.abbreviation + ""
    default: return "Company registration number"
  }

}

function verifyZero(immatriculation: string): boolean {
  return !Number.isNaN(Number(immatriculation)) && Number(immatriculation) > 0
}

function verifyFR(immatriculation: string): boolean {
  return verifyZero(immatriculation) && immatriculation !==  '12312312312312' &&  (stdnum.FR.siren.validate(immatriculation).isValid || stdnum.FR.siret.validate(immatriculation).isValid)
}

export function verifyFR_SR(immatriculation: string): boolean {
  return verifyZero(immatriculation) && immatriculation !==  '12312312312312' && (stdnum.FR.siret.validate(immatriculation).isValid)
}

export function verifyFR_SN(immatriculation: string): boolean {
  return verifyZero(immatriculation) && (stdnum.FR.siren.validate(immatriculation).isValid)
}

function verifyIT(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.IT.iva.validate(immatriculation).isValid
}
function verifyES(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.ES.nif.validate(immatriculation).isValid
}

function verifyBE(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.BE.vat.validate(immatriculation).isValid
}


function verifyLU(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.LU.tva.validate(immatriculation).isValid
}

function verifyNL(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.NL.btw.validate(immatriculation).isValid
}

function verifyGB(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.GB.vat.validate(immatriculation).isValid
}

function verifyDE(immatriculation: string): boolean {
  return immatriculation === '' || stdnum.DE.vat.validate(immatriculation).isValid
}

